export default __webpack_public_path__ + "8313687aaf8ec01d6b8f9b7e9352c292.ttf";